/* 9R STUDIOS v5 — Premium JS
   Site loader, Permian-style staggered reveals, AJAX cart, variant selector */
(function(){
'use strict';

/* ═══ SITE LOADER (Permian/Casper-inspired) ═══ */
var loader = document.getElementById('site-loader');
var loaderBar = document.getElementById('loader-bar');
var loaderPct = document.getElementById('loader-pct');
var siteContent = document.getElementById('site-content');
var progress = 0;
var target = 100;

function animateLoader() {
  if (!loader) { if (siteContent) siteContent.classList.add('visible'); return; }
  var interval = setInterval(function() {
    // Ease toward target with slight randomness
    var step = Math.max(1, Math.floor((target - progress) * 0.15));
    progress = Math.min(target, progress + step);
    if (loaderBar) loaderBar.style.width = progress + '%';
    if (loaderPct) loaderPct.textContent = progress + '%';
    if (progress >= 100) {
      clearInterval(interval);
      setTimeout(function() {
        loader.classList.add('done');
        if (siteContent) siteContent.classList.add('visible');
        // Remove loader from DOM after transition
        setTimeout(function() { if (loader.parentNode) loader.parentNode.removeChild(loader); }, 700);
      }, 200);
    }
  }, 30);
}

// Start loader on DOMContentLoaded, complete on full load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { target = 60; });
} else {
  target = 60;
}
window.addEventListener('load', function() { target = 100; });
animateLoader();

/* ═══ CART TOAST ═══ */
var toast = document.createElement('div');
toast.className = 'cart-toast';
toast.id = 'cart-toast';
toast.innerHTML = '<svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg><span>Added to cart</span>';
document.body.appendChild(toast);
function showToast(m) {
  toast.querySelector('span').textContent = m || 'Added to cart';
  toast.classList.add('show');
  clearTimeout(toast._t);
  toast._t = setTimeout(function() { toast.classList.remove('show'); }, 2400);
}

/* ═══ MOBILE MENU ═══ */
var toggle = document.getElementById('menu-toggle');
var menu = document.getElementById('mobile-menu');
if (toggle && menu) {
  toggle.addEventListener('click', function(e) {
    e.stopPropagation();
    var isOpen = menu.classList.contains('open');
    if (isOpen) {
      menu.classList.remove('open');
      toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    } else {
      menu.classList.add('open');
      toggle.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
  });
  // Close menu when clicking a link
  menu.querySelectorAll('a').forEach(function(link) {
    link.addEventListener('click', function() {
      menu.classList.remove('open');
      toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  });
}

/* ═══ INTERSECTION OBSERVER REVEALS (Permian-style) ═══ */
function initReveals() {
  var sections = document.querySelectorAll('[data-reveal]');
  if (!sections.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('revealed');
        var children = e.target.querySelectorAll('[data-reveal-child]');
        children.forEach(function(child, i) {
          var d = parseInt(child.dataset.delay) || i;
          child.style.transitionDelay = (d * 0.1) + 's';
          // Use rAF for smoother paint
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              child.classList.add('revealed');
            });
          });
        });
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.06, rootMargin: '0px 0px -60px 0px' });
  sections.forEach(function(s) { obs.observe(s); });
}
// Init reveals after loader finishes
window.addEventListener('load', function() {
  setTimeout(initReveals, 800);
});

/* ═══ GALLERY CAROUSEL ═══ */
var track = document.getElementById('gallery-track');
var prevBtn = document.getElementById('gallery-prev');
var nextBtn = document.getElementById('gallery-next');
if (track && prevBtn && nextBtn) {
  var slideW = function() {
    var s = track.querySelector('.gallery-slide');
    return s ? (s.offsetWidth + 20) : 400;
  };
  prevBtn.addEventListener('click', function() { track.scrollBy({ left: -slideW(), behavior: 'smooth' }); });
  nextBtn.addEventListener('click', function() { track.scrollBy({ left: slideW(), behavior: 'smooth' }); });
}

/* ═══ REVIEWS CAROUSEL ═══ */
var rTrack = document.getElementById('reviews-track');
var rPrev = document.getElementById('reviews-prev');
var rNext = document.getElementById('reviews-next');
if (rTrack && rPrev && rNext) {
  var rSlideW = function() { var s = rTrack.querySelector('.review-slide'); return s ? s.offsetWidth : 400; };
  rPrev.addEventListener('click', function() { rTrack.scrollBy({ left: -rSlideW(), behavior: 'smooth' }); });
  rNext.addEventListener('click', function() { rTrack.scrollBy({ left: rSlideW(), behavior: 'smooth' }); });
}

/* ═══ PRODUCT PAGE VARIANT SELECTOR ═══ */
var pdp = document.querySelector('.pdp:not(.pdp--homepage)');
if (pdp) {
  var pj = document.getElementById('product-json');
  var product = null;
  try { product = JSON.parse(pj.textContent); } catch(e) {}
  if (product) {
    var vs = document.getElementById('variant-select');
    var priceEl = document.getElementById('pdp-price');
    var atcBtn = pdp.querySelector('.atc-btn');
    var opts = {};
    product.options.forEach(function(o, i) {
      var g = pdp.querySelector('[data-option-index="' + i + '"]');
      if (g) { var s = g.querySelector('.selected'); if (s) opts[i] = s.dataset.value; }
    });
    pdp.querySelectorAll('.pdp-variant-options').forEach(function(g) {
      var idx = parseInt(g.dataset.optionIndex);
      g.querySelectorAll('.pdp-opt').forEach(function(b) {
        b.addEventListener('click', function() {
          g.querySelectorAll('.pdp-opt').forEach(function(x) { x.classList.remove('selected'); });
          b.classList.add('selected'); opts[idx] = b.dataset.value; uv();
        });
      });
    });
    pdp.querySelectorAll('.pdp-frame-options').forEach(function(g) {
      var idx = parseInt(g.dataset.optionIndex);
      g.querySelectorAll('.pdp-frame-opt').forEach(function(b) {
        b.addEventListener('click', function() {
          g.querySelectorAll('.pdp-frame-opt').forEach(function(x) { x.classList.remove('selected'); });
          b.classList.add('selected'); opts[idx] = b.dataset.value; uv();
          var asm = document.getElementById('assembly-options');
          if (asm) { var p = asm.closest('.pdp-variant-group'); if (p) p.style.display = b.classList.contains('no-frame') ? 'none' : ''; }
        });
      });
    });
    function uv() {
      var so = []; product.options.forEach(function(o, i) { if (opts[i]) so.push(opts[i]); });
      var m = null;
      for (var v = 0; v < product.variants.length; v++) {
        var vr = product.variants[v], ok = true;
        for (var o = 0; o < so.length; o++) { if (vr.options[o] !== so[o]) { ok = false; break; } }
        if (ok) { m = vr; break; }
      }
      if (m) {
        vs.value = m.id;
        if (priceEl) priceEl.textContent = fm(m.price);
        if (atcBtn) {
          if (m.available) { atcBtn.disabled = false; atcBtn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18"/><path d="M16 10a4 4 0 01-8 0"/></svg> Add to Cart'; }
          else { atcBtn.disabled = true; atcBtn.innerHTML = 'Sold Out'; }
        }
        var u = new URL(window.location); u.searchParams.set('variant', m.id); window.history.replaceState({}, '', u);
      }
    }
    var form = document.getElementById('product-form');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function(r) { return r.json(); })
          .then(function() { showToast('Added to cart'); uc(); })
          .catch(function(err) { console.error(err); });
      });
    }
  }
  // Thumbnails
  pdp.querySelectorAll('.pdp-thumb').forEach(function(t) {
    t.addEventListener('click', function() {
      var idx = t.dataset.index;
      pdp.querySelectorAll('.pdp-thumb').forEach(function(x) { x.classList.remove('active'); });
      t.classList.add('active');
      pdp.querySelectorAll('.pdp-main-img').forEach(function(img) {
        img.classList.toggle('active', img.dataset.index === idx);
      });
    });
  });
  // Quantity
  var qi = pdp.querySelector('.qty-val');
  if (qi) {
    pdp.querySelectorAll('.qty-btn').forEach(function(b) {
      b.addEventListener('click', function() {
        var v = parseInt(qi.value) || 1;
        v += b.dataset.action === 'increase' ? 1 : -1;
        qi.value = Math.max(1, Math.min(20, v));
      });
    });
  }
}

/* ═══ QUICK ADD ═══ */
document.addEventListener('click', function(e) {
  var chip = e.target.closest('.quick-chip[data-variant-id]');
  if (!chip) return;
  e.preventDefault(); e.stopPropagation();
  chip.classList.add('adding');
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(chip.dataset.variantId), quantity: 1 })
  })
    .then(function(r) { return r.json(); })
    .then(function() { showToast('Added to cart'); uc(); chip.classList.remove('adding'); })
    .catch(function() { chip.classList.remove('adding'); });
});

/* ═══ CART COUNT ═══ */
function uc() {
  fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
    document.querySelectorAll('.cart-count').forEach(function(el) {
      el.textContent = c.item_count;
      // Bounce animation
      el.style.transform = 'scale(1.3)';
      setTimeout(function() { el.style.transform = 'scale(1)'; }, 300);
    });
  });
}

/* ═══ CART PAGE QTY ═══ */
document.querySelectorAll('.qty-btn-sm').forEach(function(b) {
  b.addEventListener('click', function() {
    var l = b.dataset.line;
    var inp = document.querySelector('.qty-val-sm[data-line="' + l + '"]');
    if (!inp) return;
    var v = parseInt(inp.value) || 1;
    v += b.dataset.action === 'increase' ? 1 : -1;
    inp.value = Math.max(0, v);
    inp.closest('form').submit();
  });
});

/* ═══ SORT ═══ */
var ss = document.getElementById('sort-by');
if (ss) { ss.addEventListener('change', function() { var u = new URL(window.location); u.searchParams.set('sort_by', this.value); window.location = u; }); }

/* ═══ RECOVER ═══ */
if (window.location.hash === '#recover') { var r = document.getElementById('recover'); if (r) r.style.display = 'block'; }

function fm(c) { return '\u20AC' + (c / 100).toFixed(2).replace('.', ','); }
})();
